import { Box, IconButton, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'
import EnFlag from '../../assets/en.png'
import ViFlag from '../../assets/vi.png'
import SmartImage from '../SmartImage'

const LanguageSelector = () => {
  const [t, i18n] = useTranslation()

  const handleChangeLocale = (locale: string) => {
    i18n.changeLanguage(locale)
    localStorage.setItem('locale', locale)
  }
  return (
    <Box style={{ display: 'flex' }} gap={1}>
      <Tooltip title={t('language-selector.languages.vi')} followCursor>
        <IconButton
          sx={{ width: 40, height: 40 }}
          onClick={() => handleChangeLocale('vi')}
          aria-label={t('language-selector.languages.vi')}>
          <SmartImage
            src={ViFlag}
            alt=""
            width={24}
            height={16}
            customStyle={{
              height: 16,
              width: 24,
              borderRadius: 2,
              objectFit: 'cover',
            }}
          />
        </IconButton>
      </Tooltip>
      <Tooltip title={t('language-selector.languages.en')} followCursor>
        <IconButton
          sx={{ width: 40, height: 40 }}
          onClick={() => handleChangeLocale('en')}
          aria-label={t('language-selector.languages.en')}>
          <SmartImage
            src={EnFlag}
            alt=""
            width={24}
            height={14}
            customStyle={{
              height: 14,
              width: 24,
              borderRadius: 2,
              objectFit: 'cover',
            }}
          />
        </IconButton>
      </Tooltip>
    </Box>
  )
}

export default LanguageSelector
